<template>
  <div class="scriptCenter">
    <div class="scriptCenter_title">
      <div class="line"></div>
      <div class="title">前期沟通</div>
    </div>
    <!-- 前期沟通表格 -->
    <div class="communication_table">
      <table class="tb1" cellspacing="0">
        <tr class="th">
          <th style="width: 243px">大纲</th>
          <th style="width: 1096px">内容</th>
          <th style="width: 219px">操作</th>
        </tr>
        <tr class="tr_item" v-for="(item, index) in selectScriptManagement" :key="index">
          <td class="outline">
            <el-input @change="outlineChange(item)" v-model="item.outline"></el-input>
          </td>
          <td class="content">
            <el-input
              @change="outlineChange(item)"
              type="textarea"
              v-model="item.content"
            ></el-input>
          </td>
          <td class="options">
            <span class="duplication" @click="clickDuplicationCommunication(item.content)"
              >复制</span
            >
            <span class="remove" @click="clickRemoveCommunication(item.id)">删除</span>
          </td>
        </tr>
        <tr>
          <td colspan="3" class="add" @click="clickAddCommunication">+添加</td>
        </tr>
      </table>
    </div>

    <!-- 面试问题   problem -->
    <div class="scriptCenter_title" style="margin-top: 23px">
      <div class="line"></div>
      <div class="title">面试问题</div>
    </div>
    <div class="communication_table">
      <table class="tb1" cellspacing="0">
        <tr class="th">
          <th style="width: 243px">大纲</th>
          <th style="width: 1096px">内容</th>
          <th style="width: 219px">操作</th>
        </tr>
        <tr class="tr_item" v-for="(item, index) in selectScriptManagementTwo" :key="index">
          <td class="outline">
            <el-input @change="contentChange(item)" v-model="item.outline"></el-input>
          </td>
          <td class="content">
            <el-input
              @change="contentChange(item)"
              type="textarea"
              v-model="item.content"
            ></el-input>
          </td>
          <td class="options">
            <span class="duplication" @click="clickDuplicationProblem(item.content)">复制</span>
            <span class="remove" @click="clickRemoveProblem(item.id)">删除</span>
          </td>
        </tr>
        <tr>
          <td colspan="3" class="add" @click="clickAddProblem">+添加</td>
        </tr>
      </table>
    </div>
  </div>
</template>
<script>
import { selectScriptManagement, removeDelete, addSave, update } from '@/api/projectCenter.js'

export default {
  components: {},
  data() {
    return {
      selectScriptManagement: [],
      selectScriptManagementTwo: [],
      query: {
        projectId: ''
      }
    }
  },

  computed: {
    item() {
      return JSON.parse(this.$route.query.item)
    }
  },

  watch: {},
  created() {
    this.query.projectId = this.item.id
    this.search()
  },
  methods: {
    async search() {
      const { data: res } = await selectScriptManagement(this.query)
      if (res.resultCode == 200) {
        this.selectScriptManagement = res.data.selectScriptManagement
        this.selectScriptManagementTwo = res.data.selectScriptManagementTwo
      }
    },
    //前期沟通表格 点击复制
    clickDuplicationCommunication(content) {
      let input = document.createElement('input') // 创建input对象
      input.value = content // 设置复制内容
      document.body.appendChild(input) // 添加临时实例
      input.select() // 选择实例内容
      document.execCommand('Copy') // 执行复制
      document.body.removeChild(input) // 删除临时实例
      this.$message.success('复制成功！')
    },
    //前期沟通表格 点击删除
    async clickRemoveCommunication(id) {
      const { data: res } = await removeDelete({ id })
      if (res.resultCode == 200) {
        this.$message.success('删除成功')
        this.search()
      }
    },
    // 前期沟通表格 点击添加
    async clickAddCommunication() {
      let query = {
        content: '',
        createName: '',
        createTime: '',
        outline: '',
        state: '1',
        updateName: '',
        updateTime: '',
        projectId: this.item.id
      }
      const { data: res } = await addSave(query)
      if (res.resultCode == 200) {
        this.$message.success('添加成功')
        this.search()
      }
    },

    // 修改
    async outlineChange(item) {
      let query = {
        content: item.content,
        createName: '',
        createTime: '',
        id: item.id,
        outline: item.outline,
        projectId: this.item.id,
        state: '1',
        updateName: '',
        updateTime: ''
      }

      const { data: res } = await update(query)
      if (res.resultCode == 200) {
        console.log(res)
      }
    },
    async contentChange(item) {
      let query = {
        content: item.content,
        createName: '',
        createTime: '',
        id: item.id,
        outline: item.outline,
        projectId: this.item.id,
        state: '2',
        updateName: '',
        updateTime: ''
      }

      const { data: res } = await update(query)
      if (res.resultCode == 200) {
        console.log(res)
      }
    },

    //面试问题 点击复制
    clickDuplicationProblem(content) {
      let input = document.createElement('input') // 创建input对象
      input.value = content // 设置复制内容
      document.body.appendChild(input) // 添加临时实例
      input.select() // 选择实例内容
      document.execCommand('Copy') // 执行复制
      document.body.removeChild(input) // 删除临时实例
      this.$message.success('复制成功！')
    },
    //面试问题 点击删除
    async clickRemoveProblem(id) {
      const { data: res } = await removeDelete({ id })
      if (res.resultCode == 200) {
        this.$message.success('删除成功')
        this.search()
      }
    },
    // 面试问题 点击添加
    async clickAddProblem() {
      let query = {
        content: '',
        createName: '',
        createTime: '',
        outline: '',
        state: '2',
        updateName: '',
        updateTime: '',
        projectId: this.item.id
      }
      const { data: res } = await addSave(query)
      if (res.resultCode == 200) {
        this.$message.success('添加成功')
        this.search()
      }
    }
    //
  }
}
</script>
<style scoped lang="less">
.scriptCenter {
  background-color: #fff;
  padding-left: 30px;
  height: calc(100vh - 338px);
  padding-bottom: 20px;
  overflow: auto;
  .scriptCenter_title {
    height: 45px;
    display: flex;
    align-items: center;
    .line {
      width: 4px;
      height: 18px;
      border-radius: 1px;
      background-color: #17757a;
      margin-right: 8px;
    }
    .title {
      color: #17757a;
      font-size: 16px;
      font-weight: 600;
    }
  }

  .communication_table {
    .tb1 {
      margin: 0;
      text-align: center;
      border: 1px solid #dddddd;
      border-collapse: collapse;

      /deep/.el-input__inner {
        border: none;
        text-align: center;
      }

      /deep/.el-textarea__inner {
        border: none;
        text-align: center;
      }

      td {
        font-size: 12px;
        border: 1px solid #dddddd;
      }

      .tr_item {
        height: 30px;

        .options {
          font-size: 12px;
          .duplication {
            color: #17757a;
            margin-right: 17px;
            cursor: pointer;
          }
          .remove {
            color: #fa5050;
            cursor: pointer;
          }
        }
      }

      .th {
        background-color: #f3f6fd;
        height: 36px;
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
        font-size: 14px;
        font-weight: 400;
        color: #333;
      }
      .add {
        height: 32px;
        color: #17757a;
        font-size: 14px;
        cursor: pointer;
      }
    }
  }
}
</style>
